<template>
  <InfoContent>
    <div class="info-lead">
      <p>
        Enregistrer « Ne répond pas » note votre tentative d'appel et prévient le
        client par e-mail. <strong>Aucune tâche n'est créée</strong> : rien
        n'apparaît dans « Mes tâches du jour ».
      </p>
    </div>

    <div class="info-section">
      <h3><i class="fas fa-bolt"></i> Tout de suite</h3>
      <div class="info-item">
        <div class="info-item-content">
          <p>
            <strong>Le client reçoit l'e-mail choisi</strong>, envoyé au nom du
            commercial de la demande (le vôtre si elle n'en a pas). Avec la
            proposition de RDV téléphonique, il contient un bouton pour demander à
            être rappelé.
          </p>
          <p>
            <strong>L'appel s'ajoute à l'historique</strong> de la demande, avec la
            réponse « Répondeur ». Votre commentaire, s'il y en a un, rejoint les
            commentaires de la demande.
          </p>
          <p>
            Une demande encore au statut « Demande de devis » passe en
            <strong>« Appel de qualification »</strong>.
          </p>
        </div>
      </div>
      <p class="info-note">
        <i class="fas fa-envelope"></i>
        L'e-mail repart à chaque « Ne répond pas » enregistré.
      </p>
    </div>

    <div class="info-section">
      <h3><i class="fas fa-calendar-day"></i> Sept jours après le dernier « Ne répond pas »</h3>
      <div class="info-item">
        <div class="info-item-content">
          <p>
            Si aucun appel n'a été décroché depuis, que la demande a un commercial
            et qu'elle est <strong>déjà chiffrée</strong>, le devis est
            <strong>envoyé automatiquement</strong> au client.
          </p>
          <p>
            Sans montant fixé, rien ne part : c'est à vous de chiffrer et d'envoyer
            le devis.
          </p>
        </div>
      </div>
      <p class="info-note">
        <i class="fas fa-phone"></i>
        Une réponse du client par e-mail n'arrête pas cet envoi : seul un appel
        décroché l'arrête, ou une relance programmée.
      </p>
    </div>
  </InfoContent>
</template>

<script setup>
import InfoContent from './InfoContent.vue'
</script>
